import {ReportData} from "../../../reports/report.data";
import {collection} from "@fedeltapointofsale/data-client";


export class ExtrasSoldReportData extends ReportData<ExtrasSoldReportData> {
    @collection() groupBy: string[] = ["none"];
}
